import type { SVGProps } from 'react'
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={18}
    fill="none"
    viewBox="0 0 22 18"
    {...props}
  >
    <path
      fill="#0F141E"
      fillRule="evenodd"
      d="M19.4.833H2.6c-.99 0-1.825.694-2.044 1.619L11 9.098l10.444-6.646A2.11 2.11 0 0 0 19.4.833m2.1 3.954-9.963 6.34a1 1 0 0 1-1.074 0L.5 4.787v10.746c0 1.155.945 2.1 2.1 2.1h16.8c1.155 0 2.1-.945 2.1-2.1z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMail
